// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-selector > li[data-v-59fac3e2] {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
